import type { StyleRule } from '@archipro-design/aria';
import { buttonClassName, pxArrayToRem, pxToRem } from '@archipro-design/aria';
import { svgIconClassName } from '@archipro-design/icons';

export const MinorDetail: StyleRule = ({ theme }) => ({
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    marginBottom: theme.siteVariables.spaces['space-16'],
    [theme.screen.tablet]: {
        marginBottom: 0,
    },
});

export const SaveShareContainer: StyleRule = () => ({
    paddingTop: pxToRem(25),
    paddingBottom: pxToRem(25),
});

export const LinkButton: StyleRule = () => ({
    textDecoration: 'underline',
    '& > span': {
        marginRight: pxToRem(10),
    },
});

export const ButtonHeart: StyleRule = ({ theme }) => ({
    [`& .${buttonClassName}:hover`]: {
        background: 'transparent',
    },
    [`& .${svgIconClassName}`]: {
        width: pxToRem(16),
        height: pxToRem(16),
        [theme.screen.tablet]: {
            width: pxToRem(22),
            height: pxToRem(22),
        },
    },
});

export const Availability: StyleRule = ({ theme }) => ({
    margin: pxArrayToRem([16, 0, 0, 18]),
    [theme.screen.tablet]: {
        margin: pxArrayToRem([0, 16, 16, 0]),
    },
});
